module.exports = __webpack_public_path__ + "img/sign-28.dd4a9e72.jpg";